import axios from 'axios'

const BASE_URI = 'http://www.selidaire-varan.fr:9999'

const APIClient = {
  signin (userId, password) {
    var data = { 'userid': userId, 'Password': password }
    var config = { 'Content-Type': 'application/json' }
    return this.perform('post', '/sign-in', JSON.stringify(data), config)
  },
  getDoc (filename) {
    return this.perform('get', '/docs/' + filename, { responseType: 'blob' })
  },
  getPicture (filename) {
    return this.perform('get', '/images/' + filename, { responseType: 'arraybuffer' })
  },
  getEvents () {
    return this.perform('get', '/events')
  },
  getEventsByType (eventtype) {
    return this.perform('get', '/events/?type=' + String(eventtype))
  },
  getLatestEventByType () {
    return this.perform('get', '/event-latest')
  },
  deleteEvent (eventid) {
    return this.perform('get', '/delete-event/?id=' + String(eventid))
  },
  getEventTypes () {
    return this.perform('get', '/event-types', {}, { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  addEvent (date, title, eventtype, description, file, picture) {
    var data = { 'date': date, 'title': title, 'eventtype': eventtype, 'description': description, 'docpath': null, 'picturepath': null }
    var bodyFormData = new FormData()
    bodyFormData.append('data', JSON.stringify(data))
    bodyFormData.append('file', file)
    bodyFormData.append('picture', picture)
    return this.perform('post', '/add-event', bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  modifyEvent (eventid, date, title, eventtype, description, docpath, picturepath) {
    var data = { 'date': date, 'title': title, 'eventtype': eventtype, 'description': description, 'docpath': docpath, 'picturepath': picturepath }
    return this.perform('post', '/modify-event/?id=' + String(eventid), JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  getUsers () {
    return this.perform('get', '/get-users')
  },
  getRoles () {
    return this.perform('get', '/roles')
  },
  addUser (userid, firstname, lastname, role) {
    var data = { 'UserId': userid, 'FirstName': firstname, 'LastName': lastname, 'Role': role }
    return this.perform('post', '/add-user', JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  modifyUser (userid, firstname, lastname, role) {
    var data = { 'UserId': userid, 'FirstName': firstname, 'LastName': lastname, 'Role': role }
    return this.perform('post', '/modify-user/?id=' + userid, JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  deleteUser (userid) {
    return this.perform('get', '/delete-user/?id=' + String(userid))
  },
  addUsersBulk (file) {
    var bodyFormData = new FormData()
    bodyFormData.append('data', JSON.stringify({}))
    bodyFormData.append('file', file)
    return this.perform('post', '/add-users', bodyFormData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  getFollowers () {
    return this.perform('get', '/followers')
  },
  getFollowersByType (followingtype) {
    return this.perform('get', '/followers/?type=' + String(followingtype))
  },
  deleteFollower (followerId) {
    return this.perform('get', '/delete-follower/?id=' + String(followerId))
  },
  getFollowingTypes () {
    return this.perform('get', '/following-types', {}, { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  addFollower (firstname, lastname, mail, firm, fct, acceptnews, followingtype) {
    var data = { 'firstname': firstname, 'lastname': lastname, 'mail': mail, 'firm': firm, 'function': fct, 'acceptNews': acceptnews, 'followingType': followingtype }
    return this.perform('post', '/add-follower', JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  modifyFollower (followerId, firstname, lastname, mail, firm, fct, acceptnews, followingtype) {
    var data = { 'followerId': followerId, 'firstname': firstname, 'lastname': lastname, 'mail': mail, 'firm': firm, 'function': fct, 'acceptNews': acceptnews, 'followingType': followingtype }
    return this.perform('post', '/modify-follower/?id=' + followerId, JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  getTokenWhiteBook (language) {
    return this.perform('get', '/token-whitebook/?lang=' + language)
  },
  getWhitebook (token) {
    return this.perform('get', '/download/?token=' + token)
  },
  getTirs () {
    return this.perform('get', '/tirs')
  },
  getTirsPublic () {
    return this.perform('get', '/tirs-public')
  },
  deleteTir (tirId) {
    return this.perform('get', '/delete-tir/?id=' + String(tirId))
  },
  addTir (name, address, postal_code, town, date, intensity) {
    var data = { 'name': name, 'address': address, 'postalCode': postal_code, 'town': town, 'date': date, 'intensity': intensity }
    return this.perform('post', '/add-tir', JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  modifyTir (tirId, name, address, postal_code, town, date, intensity) {
    var data = { 'tirId': tirId, 'name': name, 'address': address, 'postalCode': parseInt(postal_code), 'town': town, 'date': date, 'intensity': parseInt(intensity) }
    return this.perform('post', '/modify-tir/?id=' + tirId, JSON.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' })
  },
  async perform (method, resource, data, config) {
    axios.defaults.withCredentials = true
    if (method === 'post') {
      return axios.post(BASE_URI + resource, data, config)
    } else if (method === 'get') {
      return axios.get(BASE_URI + resource, data, config)
    }
  }
}

export default APIClient
